
<div class="statusbar">    
    <div class="left">{{lblDevEnv}}</div>
   
    <div class="center"><span class="span">{{statusMessage}}</span></div>
    <div class="right"><span class="span">Version:{{version}}</span></div> 
</div>